import styled from 'styled-components';
import { FONTS, SIZE } from '@app/src/ui';

export const TitleModal = styled.h4`
  font-family: ${FONTS.ARISTOTELICA};
  font-size: 20px;
  line-height: 22px;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 24px;
    line-height: 26px;
  }
`;

export const SubtitlePublish = styled.p`
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  margin: 20px 0 6px 0;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const DescriptionModal = styled.p`
  margin-top: 0px;
  font-size: 12px;
  line-height: 16px;
  padding: 0 5px;
  margin: 0 0 6px 0;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ModalBody = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  margin-top: 50px;
  box-sizing: border-box;
  text-align: center;
  max-width: 280px;
  padding: 0 15px 30px;
`;
